import { HttpService } from '../main/HttpService.js';
import { UrlUtils } from '../main/ObjectUtils.js';

/*# This class' sole purpose is to communicate with the server. #*/
export class DesignerAppService extends HttpService {
  constructor(serviceUrl) {
    super(serviceUrl);
    //this.sameSiteOnly = true; // See super() for info
  }

  async helloAsync(name, signal) {
    return await this.fetchText(`hello?name=${name}`, { signal });
  }

  /** Creates a Designer telemetry session. The whole purpose is to monitor/report how Designer is being used. */
  async createDesignerTelemetrySessionAsync(eventType, creatorName, signal) {
    return await this.post(`sessions?eventType=${eventType}&creatorName=${encodeURIComponent(creatorName)}`, [], null, signal);
  }

  /** Updates the Designer telemetry session. The whole purpose is to monitor/report how Designer is being used. */
  async updateDesignerTelemetrySessionAsync(sessionId, osCategory, operatingSystem, osVersion,
    browserCategory, browser, userAgent, signal) {
    // Note, the winVersion key should be named osVersion, but we won't update the server for now for compatibility reasons.
    return await this.put(`sessions?sessionId=${sessionId}&osCategory=${osCategory}` +
      `&operatingSystem=${encodeURIComponent(operatingSystem)}&winVersion=${osVersion}` +
      `&browserCategory=${browserCategory}&browser=${encodeURIComponent(browser)}&userAgent=${encodeURIComponent(userAgent)}`,
      [], null, signal);
  }

  /** Updates the Designer telemetry session. The whole purpose is to monitor/report how Designer is being used. */
  async createAndUpdateDesignerTelemetrySessionAsync(osCategory, operatingSystem, osVersion,
    browserCategory, browser, userAgent, eventType, creatorName, signal) {
    return await this.put(`sessions?sessionId=null&osCategory=${osCategory}` +
      `&operatingSystem=${encodeURIComponent(operatingSystem)}&winVersion=${osVersion}` +
      `&browserCategory=${browserCategory}&browser=${encodeURIComponent(browser)}&userAgent=${encodeURIComponent(userAgent)}` +
      `&createNewSession=true&eventType=${eventType}&creatorName=${encodeURIComponent(creatorName)}`,
      [], null, signal);
  }

  /** Reports an event with the Designer telemetry session. The whole purpose is to monitor/report how Designer is being used. */
  async reportDesignerTelemetrySessionEventAsync(sessionId, eventType, signal) {
    return await this.post(`sessionevents?sessionId=${sessionId}&eventType=${eventType}`, [], null, signal);
  }

  async getFullAppUrlAsync(selectedAppId, culture, preferredCustNo, preferredCustomerGroupId, userType, /*Guid*/ designerSessionId, signal) {
    //const url1 = `full-app-uri?selectedAppId=${selectedAppId}&culture=${culture}` +
    //  `&preferredCustNo=${preferredCustNo}&preferredCustomerGroupId=${preferredCustomerGroupId}` +
    //  `&userType=${userType}&designerSessionId=${designerSessionId}`;

    const queryStringParams = {
      selectedAppId,
      culture,
      preferredCustNo,
      preferredCustomerGroupId,
      userType,
      designerSessionId
    };
    const url = UrlUtils.createUrlWithQueryString('full-app-uri', queryStringParams, /*ignoreNullValues:*/ true);
    return await this.fetchText(url, { signal });
  }

  async createBootstrapSession(designerUrl, signal) {
    let url = designerUrl
      ? `bootstrap-sessions?designerUrl=${encodeURIComponent(designerUrl)}`
      : 'bootstrap-sessions';
    return await this.fetchText(url, { method: 'POST', signal });
  }

  /**
   * Asks the server for the current Bootstrap status.
   * @returns One of the following values as a plain string: (null), Unset, Installing, Installed, BootstrapStarted, AppLaunched, AppStarted.
   */
  async getBootstrapSessionStatus(sessionId, signal) {
    return await this.fetchText(`bootstrap-sessions/${sessionId}/status`, { signal });
  }

  async downloadBootstrapAppAsync(signal) {
    return await this.getBlob('bootstrap-app-file', { signal });
  }
}
